module.exports = __webpack_public_path__ + "static/media/440441366_1513823449548608_3081678978802798798_n.d90cd5c1.jpg";